import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Components/Navbar/Navbar';
import Banner from '../Components/Banner/Banner';
import Analytics from '../Components/Analytics/Analytics';
import About from '../Components/About/About';
import Team from '../Components/Team/Team'
import Pricing from '../Components/Pricing/Pricing'
import Faq from '../Components/Faq/Faq'
import Footer from '../Components/Footer/Footer'
import React from "react";
// import Announcement from '../Components/Announcement/Announcement';

function Landing() {
  return (
    <div>
      <Navbar />
      <Banner />
      <Analytics />
      <About />
      <Team />
      <Pricing />
      <Faq />
      <Footer />
    </div>
  );
}

export default Landing;
